import * as React from 'react'

const SvgTextStrikeThroughIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 9.375h-6.277a24.807 24.807 0 00-.837-.21C8.631 8.752 7.64 8.448 7.64 7.027c-.03-.496.15-.981.492-1.34a2.993 2.993 0 011.883-.682c1.769-.043 2.584.557 3.251 1.47l1.01-.738a4.67 4.67 0 00-4.27-1.982 4.233 4.233 0 00-2.75 1.038 3.017 3.017 0 00-.866 2.234 2.733 2.733 0 001.084 2.349H2.5v1.25h8.533c1.229.356 1.964.82 1.983 2.099a1.95 1.95 0 01-.54 1.495 3.64 3.64 0 01-2.324.78 4.146 4.146 0 01-3.216-1.68l-.958.802a5.328 5.328 0 004.155 2.129h.062a4.794 4.794 0 003.155-1.137 3.174 3.174 0 00.916-2.408 3.095 3.095 0 00-.72-2.08H17.5v-1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgTextStrikeThroughIcon
